import { connect } from 'react-redux';

import { selectSpaceInfo } from '../../app/selectors/ContentSelectors';
import { siteUrlsSelector } from '../../app/selectors/SiteUrlsSelectors';
import { AppState } from '../../app/state/AppState';
import { UrlParamKeys } from '../../app/UrlParamKeys';
import { Messages } from '../../codegen/Localize';
import { Order } from '../../ts/helpers/Order';
import { IContentInfo } from '../../ts/models/IContentInfo';
import { OrderKeys } from '../../ts/models/OrderKeys';
import { IOrderClause } from '../../ts/ServerApi/types/IOrderClause';
import { ChannelTypes } from '../types/ChannelTypes';
import { Channel, ChannelOwnProps, ChannelProps } from './Channel';

export const ConnectedPopularChannel = connect((state: AppState, props: ChannelOwnProps) => {
  const siteUrls = siteUrlsSelector(state);

  let list: IContentInfo[] = [];
  state.home.popular.items.forEach((contentId: string) => {
    list.push(state.home.contentById[contentId]);
  });

  const popularViewsLastMonthClause = Order.desc(OrderKeys.hitsLastOneMonthTotal);

  const popularChannelProps: ChannelProps = {
    channelType: ChannelTypes.popular,
    title: Messages.home_popularTitle(),
    seeAllUrl: siteUrls.viewsUrl() + createOrderQuery(popularViewsLastMonthClause),
    seeAllAltText: Messages.home_popular_alt_seeAll(),
    list,
    isFetching: state.home.popular.isFetching,
    numRows: 1,
    maxCardsPerRow: props.maxCardsPerRow,
    spaceInfo: selectSpaceInfo(state)
  };
  return popularChannelProps;
})(Channel);

/**
 * Returns "?order=[query]"
 */
function createOrderQuery(orderClause: IOrderClause): string {
  const query = Order.serialize([orderClause]);
  return `?${UrlParamKeys.Order}=${query}`;
}
